export default "__VITE_ASSET__4chkGHH5__"